import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "lock-open",
  "use": "lock-open-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"lock-open\"><title>icn/lock-open</title><path d=\"M5 6v-.5a3.5 3.5 0 0 1 6.31-2.088 1 1 0 0 1-1.605 1.194A1.5 1.5 0 0 0 7 5.5V6h4a2 2 0 0 1 2 2v3a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V8a2 2 0 0 1 2-2zm0 2v3a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1V8H5z\" id=\"lock-open_a\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol